import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import useDeleteWaterSource from '@/features/config/hooks/watersource/useDeleteWaterSource'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  name?: string
}

const DeleteWaterSourceModal = ({
  id,
  interfaceId,
  name,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteWaterSource } =
    useDeleteWaterSource()

  const handleDeleteWaterSource = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal({ interfaceId, id })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteWaterSource')}
      name={name}
      text={t('waterSourceDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteWaterSource}
      isLoading={loadingDeleteWaterSource}
    />
  )
}

export default DeleteWaterSourceModal
